<span
  matSnackBar
  role="button"
  class="flex w-full items-center justify-between"
  (click)="snackBarRef.dismiss()"
  tabindex="0"
  (keydown)="snackBarRef.dismiss()"
>
  <div class="inline-flex items-center flex-1">
    <mat-icon
      [fontIcon]="getIcon(type())"
      [class]="getIconColor(type())"
      class="mr-3 shrink-0"
    ></mat-icon>

    <div class="flex flex-col justify-center">
      @if (header()) {
        <div class="font-semibold text-lg leading-tight">
          {{ header() }}
        </div>
        @if (message()) {
          <div class="font-light" [innerHTML]="message()"></div>
        }
      } @else {
        <div class="font-light" [innerHTML]="message()"></div>
      }
    </div>
  </div>

  @if (actionLabel()) {
    <div class="ml-4 shrink-0">
      <button matButton (click)="onActionClick($event)">
        {{ actionLabel() | uppercase }}
        <mat-icon class="material-icons-outlined"> refresh</mat-icon>
      </button>
    </div>
  }
</span>
